import { List, Map } from 'immutable'

import config from '../../../../../../config'

import { BUTTONSARRAY_KEY } from './constants'

const MODULE_KEY = config.modules.portfolio.key

export const portfolioTypeBlocksSelector = (state, portfolioType) => {
    // new selected portfolio type blocks
    const portfolioBlocks = state.getIn(
        ['authorization', 'accessRights', MODULE_KEY, 'custom', 'portfolios', portfolioType, 'blocks'],
        Map()
    )
    const portfolioBlocksNames = portfolioBlocks
        .filter((block) => !block.get('isDisabled'))
        .keySeq()
        .toList()

    // blocks from data
    const buttons = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', BUTTONSARRAY_KEY, 'data'], Map())
    const buttonsNames = buttons.keySeq().toList()

    // merge all blocks from data and new portfolio type (Immutable hasn't union for Lists)
    const allBlocks = portfolioBlocksNames.toSet().union(buttonsNames.toSet()).toList()

    const buttonsToToggle = allBlocks.filter((block) => {
        // if button isn't active AND is in new portfolio type => toggle
        if (portfolioBlocksNames.includes(block) && !buttons.get(block)) return true
        // if button is active AND isn't in new portfolio type => toggle
        if (!portfolioBlocksNames.includes(block) && buttons.get(block)) return true
        return false
    })

    return buttonsToToggle
}

export const portfolioTypeToSelectSelector = (state, portfolioId) => {
    const portfolioType = state.getIn(['ui', 'modules', MODULE_KEY, 'workspace', portfolioId, 'portfolioType'], null)
    const currentPortfolioType = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', 'portfolios', 'active'], null)

    return portfolioType !== currentPortfolioType ? portfolioType : null
}

export const blocksToToggleByActivePortfolio = (state, portfolioId) => {
    const portfolio = state.getIn(['ui', 'modules', MODULE_KEY, 'workspace', portfolioId], null)
    if (!portfolio) return List()

    const portfolioBlocks = portfolio.get('blocks', Map())
    const buttons = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', BUTTONSARRAY_KEY, 'data'])

    const buttonsToToggle = buttons.reduce((acc, isActive, block) => {
        const isInPortfolioBlocks = portfolioBlocks.getIn([block, 'active'], false)

        // toggle button if is active AND isn't in portfolio blocks OR isn't active AND is in portfolio blocks
        if ((isActive && !isInPortfolioBlocks) || (!isActive && isInPortfolioBlocks)) return acc.push(block)
        // else let same state
        return acc
    }, List())

    return buttonsToToggle
}

export const getActivePortfolioId = (state) => {
    const tab =
        state.getIn(['ui', 'tabs', 'tabs'], List()).find((t) => t.get('type') === MODULE_KEY && t.get('active')) || null

    return (tab && tab.get('id')) || null
}

export const getActivePortfolioBlocksForDelete = (state, portfolioId) => {
    const blocks = state.getIn(['ui', 'workspace', MODULE_KEY, portfolioId, 'blocks'], Map())

    return blocks
        .filter((block) => block.get('level'))
        .keySeq()
        .toList()
}
